<template>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 pt-5 p-sm-5 mx-auto mt-3 mt-sm-5 cert-page-content">
    <div class="cert-article px-2 px-sm-4">
      <h3 class="mb-4">Security Breach</h3>
      <p>
        A <strong>security breach</strong> (break-in) is any incident that results in unauthorized access to computer
        data, applications,
        networks, or devices. It results in information being accessed without authorization. It distinguishes itself
        from a data breach from the fact that the security breach is effectively a break-in, whereas a data breach is
        defined as a cybercriminal getting away with information.
        <br/>
        There are a number of security breaches depending on how access has been gained like:
      </p>
      <ul>
        <li>System vulnerability exploits such as outdated software</li>
        <li>Easy to guess passwords</li>
        <li>Gaining entry via social engineering (phishing) and other malware attacks</li>
      </ul>

      <h4 class="mt-5 mb-4">Protection against security breaches includes :</h4>
      <ul>
        <li>Combining random string numbers and symbols to form a strong password</li>
        <li>Never use the same password from different accounts, to avoid One-To-All access</li>
        <li>Reducing vulnerability by deleting unused accounts rather than leaving them dormant</li>
        <li>Apply regular password changes to reduce the risk you run from unannounced data breaches</li>
        <li>Creating a fresh installation before giving away your personal computer</li>
        <li>Apply all possible phone security by using screen locks, and updates and never root or jailbreak your phone</li>
        <li>Use antivirus</li>
        <li>Avoid clicking malicious links</li>
        <li>Monitor your bank accounts regularly</li>
        <li>Never give away your personal data unless necessary</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
